import "./RegistrationInfoPage.scss";
import { useHistory } from "react-router-dom";
import { Button, Content, usePathFactory, useTranslator } from "@sia/style-guide";
import Page from "../../../Page";

const HtlRegistrationInfoPage = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const history = useHistory();

  return (
    <Page>
      <Content width={"slim"} centeredTitle={true}>
        <div className="registration-info-page">
          <h1 className="productive-heading-04">{translate("wizard.sia-ways.title")}</h1>
          <p>{translate("wizard.info.info")}</p>
          <ul className="registration-info-page__list sia-margin-03-bottom">
            <li>{translate("wizard.info.list-item.education")}</li>
            <li>{translate("wizard.info.list-item.employment")}</li>
            <li>{translate("wizard.info.list-item.refererence")}</li>
            <li>{translate("wizard.info.list-item.dossier")}</li>
          </ul>
          <p className="registration-info-page__price">{translate("wizard.info.registeration-cost")}</p>
          <div className="registration-info-page__button">
            <Button onClick={() => history.push(pathFactory.create("wizard/bachelor"))}>{translate("wizard.sia-ways.to-login.button.label")}</Button>
          </div>
        </div>
      </Content>
    </Page>
  );
};

export default HtlRegistrationInfoPage;
